export default "__VITE_ASSET__a3e974ac__"